module.exports = __webpack_public_path__ + "static/img/samajuri (15).3f665e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (15).jpg
// module id = +jeS
// module chunks = 0